<template>
    <div id="MatchTech">
        <div class="content-container back-button-container brand-primary animate__animated animate__fadeIn pb-5">
            <span class="back-button" @click="$router.push('/gp')"><i class="fa-solid fa-chevron-left"></i> Back to
                home</span>
        </div>
        <div class="content-container d-flex flex-column align-items-center justify-content-center animate__animated animate__fadeIn"
            v-if="selectedView === 'guide'">
            <div class="banner-container mb-5">
                <img src="/img/gp/appointment-info.svg" />
                <h3>Welcome to Blua, digital healthcare by Bupa</h3>
                <h2>Let’s book a digital appointment together</h2>
                <p id="collapse-1">We need to get some more information before the appointment.</p>
            </div>
            <div class="banner-container">
                <div class="info-row d-flex flex-row" v-b-toggle.collapse-1>
                    <div class="mr-4 h-100 d-flex ">
                        <i class="fa-solid fa-circle  brand-primary"></i>
                        <span class="circle-number" style="left: 10px;">1</span>
                        <div class="connect-line">
                        </div>
                    </div>
                    <div class="info">
                        <h4>Verify your identy</h4>
                        <b-collapse id="collapse-1">
                            <p class="pt-3 pb-3">Complete an ID check when booking to save time during all of your
                                future appointments.</p>
                        </b-collapse>
                    </div>
                    <div class="info-icon-container align-self-start ml-auto">
                        <i class="fa-solid fa-chevron-down"></i>
                    </div>
                </div>
                <div class="info-row d-flex flex-row" v-b-toggle.collapse-2>
                    <div class="mr-4 h-100 d-flex ">
                        <i class="fa-solid fa-circle  brand-primary"></i>
                        <span class="circle-number">2</span>
                        <div class="connect-line">
                        </div>
                    </div>
                    <div class="info">
                        <h4>Choose who you’re booking for</h4>
                        <b-collapse id="collapse-2">
                            <p class="pt-3 pb-3">If you can make bookings for others, choose whether you want an
                                appointment for yourself or
                                someone else.</p>
                        </b-collapse>
                    </div>
                    <div class="info-icon-container align-self-start ml-auto">
                        <i class="fa-solid fa-chevron-down"></i>
                    </div>
                </div>
                <div class="info-row d-flex flex-row" v-b-toggle.collapse-3>
                    <div class="mr-4 h-100 d-flex">
                        <i class="fa-solid fa-circle  brand-primary"></i>
                        <span class="circle-number">3</span>
                        <div class="connect-line">
                        </div>
                    </div>
                    <div class="info">
                        <h4>Tell us about yourself</h4>
                        <b-collapse id="collapse-3">
                            <p class="pt-3 pb-3">Fill in or review your medical history so we can get to know you
                                better.</p>
                        </b-collapse>
                    </div>
                    <div class="info-icon-container align-self-start ml-auto">
                        <i class="fa-solid fa-chevron-down"></i>
                    </div>
                </div>
                <div class="info-row d-flex flex-row" v-b-toggle.collapse-4>
                    <div class="mr-4 h-100 d-flex">
                        <i class="fa-solid fa-circle  brand-primary"></i>
                        <span class="circle-number">4</span>
                        <div class="connect-line">
                        </div>
                    </div>
                    <div class="info">
                        <h4>Tell us about any symptoms</h4>
                        <b-collapse id="collapse-4">
                            <p class="pt-3 pb-3">We’ll match you to the best clinician for you based on your symptoms.
                                This could be a GP, advanced nurse practitioner, physiotherapist or mental health
                                specialist.</p>
                        </b-collapse>
                    </div>
                    <div class="info-icon-container align-self-start ml-auto">
                        <i class="fa-solid fa-chevron-down"></i>
                    </div>
                </div>
                <div class="info-row d-flex flex-row" v-b-toggle.collapse-5>
                    <div class="mr-4 h-100 d-flex ">
                        <i class="fa-solid fa-circle  brand-primary"></i>
                        <span class="circle-number">5</span>
                        <div class="connect-line">
                        </div>
                    </div>
                    <div class="info">
                        <h4>Select an appointment type</h4>
                        <b-collapse id="collapse-5">
                            <p class="pt-3 pb-3">Select either a video or an audio appointment with your clinician. Both
                                appointments types take place through the app or website. You won’t get a phone call.
                            </p>
                        </b-collapse>
                    </div>
                    <div class="info-icon-container align-self-start ml-auto">
                        <i class="fa-solid fa-chevron-down"></i>
                    </div>
                </div>
                <div class="info-row d-flex flex-row" v-b-toggle.collapse-6>
                    <div class="mr-4 h-100 d-flex number-container">
                        <i class="fa-solid fa-circle  brand-primary"></i>
                        <span class="circle-number">6</span>
                        <div class="connect-line">
                        </div>
                    </div>
                    <div class="info">
                        <h4>Choose a date and time</h4>
                        <b-collapse id="collapse-6">
                            <p class="pt-3 pb-3">Pick a time for your appointment that works around your schedule.</p>
                        </b-collapse>
                    </div>
                    <div class="info-icon-container align-self-start ml-auto">
                        <i class="fa-solid fa-chevron-down"></i>
                    </div>
                </div>
                <div class="info-row d-flex flex-row" v-b-toggle.collapse-7>
                    <div class="mr-4 h-100 d-flex ">
                        <i class="fa-solid fa-circle  brand-primary"></i>
                        <span class="circle-number">7</span>
                    </div>
                    <div class="info">
                        <h4>Confirm your appointment</h4>
                        <b-collapse id="collapse-7">
                            <p class="pt-3 pb-3">Confirm your details and appointment information and that’s it. We’ll
                                see you at your appointment.</p>
                        </b-collapse>
                    </div>
                    <div class="info-icon-container align-self-start ml-auto">
                        <i class="fa-solid fa-chevron-down"></i>
                    </div>
                </div>
            </div>
            <div class="do-not-ask-container">
                <i class="far clickable" :class="[doNotShow ? 'fa-check-square' : 'fa-square']"
                    @click="toggleDoNotShow()"></i>
                Don’t show me this again
            </div>
            <div class="prompt-container d-flex flex-row justify-content-center align-self-center mb-5 pb-5 mt-5"
                style="gap: 20px;">
                <b-button variant="cta-outline" size="lg" squared @click="$router.push('/gp')">Back</b-button>
                <b-button variant="cta" size="lg" squared @click="selectView('start')">Next</b-button>
            </div>
        </div>
        <div class="content-container warning-container d-flex flex-column align-items-center justify-content-center animate__animated animate__fadeIn"
            v-else-if="selectedView === 'start'">
            <h3 class="pb-5 brand-text align-self-center">Book a digital appointment</h3>
            <p class="pb-5 text-center">Before you start your booking, please read the following information.</p>
            <h4 class="brand-text mb-0 pb-2">Privacy Policy</h4>
            <p class="pb-5 text-center">
                We'll use any personal information you provide in line with our <a target="_blank"
                    href="https://www.bupa.co.uk/legal-notices/privacy-and-cookies" class="d-inline">privacy policy</a>.
            </p>
            <div class="warning-info-container d-flex flex-row justify-content-start align-items-center mt-3">
                <i class="fa-solid fa-circle-exclamation fa-3x mr-4"></i>
                <p class="mb-0">If you have a medical emergency, please don't wait for an appointment. You should call
                    999 or go to your nearest A&amp;E.</p>
            </div>
            <div class="d-flex flex-row justify-content-center align-self-center mb-5 pb-5" style="gap: 20px">
                <b-button variant="cta-outline" size="lg" squared @click="selectView('guide')">Back</b-button>
                <b-button variant="cta" size="lg" squared @click="selectView('journey')">Next</b-button>
            </div>
        </div>

        <div v-else-if="questionLoaded && selectedView === 'journey'" class="content-container">
            <TextPrompt v-if="currentQuestion.type === 'alert'" :prompt="currentQuestion" />
            <RadioSelectQuestion v-if="currentQuestion.type === 'radio'" :question="currentQuestion"
                :updateAnswer="updateAnswer" :showErrors="showErrors" :loadedAnswer="loadedAnswer" />
            <FormQuestion
                v-if="currentQuestion.type === 'form' && (currentQuestion.id !== 'DGB005' || manualEntryValue)"
                class="pb-5 mb-5" :question="currentQuestion" :updateAnswer="updateAnswer" :showErrors="showErrors"
                :loadedAnswer="loadedAnswer" :manualEntry="manualEntryValue"
                :manualEntryPrefilled="manualEntryPrefilled" :questionAnswer="questionAnswer" />
            <NHSLookup v-else-if="currentQuestion.type === 'form' && currentQuestion.id === 'DGB005'" class="pb-5 mb-5"
                :question="currentQuestion" :updateAnswer="updateAnswer" :showErrors="showErrors"
                :loadedAnswer="loadedAnswer" :initialSearchTerm="initialSearchTerm"
                @previous-question="previousQuestion" @manual-entry="manualEntry" />
            <ReviewDetails v-if="currentQuestion.type === 'review_form'" :title="currentQuestion.text"
                :subtitle="currentQuestion.subtitle" :previousQuestion="previousQuestion" class="pb-5 mb-5" />
            <GpPrompt v-if="currentQuestion.type === 'gp_prompt'" :type="clinicianType" :nextQuestion="nextQuestion"
                class="pb-5 mb-5" />
            <div class="button-row" v-if="currentQuestion.id !== 'DGB005' || manualEntryValue">
                <b-button variant="cta-outline" size="lg" squared @click="previousQuestion()"
                    v-if="questionHistory.length !== 0 && !$route.query.selectedTimeslotId">Previous</b-button>
                <b-button @click="selectView('start')" variant="cta-outline" size="lg" squared
                    v-else-if="!$route.query.selectedTimeslotId">Previous</b-button>
                <b-button variant="cta" size="lg" squared @click="nextQuestion()" :disabled="questionAnswer === []"
                    v-if="currentQuestion.type !== 'alert'"><span
                        v-if="$route.query.selectedTimeslotId">Update</span><span v-else>Next</span></b-button>
            </div>
        </div>
        <div class="d-flex flex-row justify-content-center" v-else>
            <b-spinner class="brand-primary"></b-spinner>
        </div>
    </div>
</template>
<script>
import axios from "axios";
import config from "../config/constants";
import FormQuestion from '../components/MatchTech/FormQuestion.vue';
import TextPrompt from '../components/MatchTech/TextPrompt.vue';
import RadioSelectQuestion from '../components/MatchTech/RadioSelectQuestion.vue';
import ReviewDetails from '../components/MatchTech/ReviewDetails.vue';
import GpPrompt from '../components/MatchTech/GpPrompt.vue';
import RedirectModal from "../components/GP/RedirectModal.vue";
import ErrorModal from "../components/GP/ErrorModal.vue";
import moment from "moment";
import NHSLookup from "../components/MatchTech/NHSLookup.vue";

export default {
    components: {
        TextPrompt,
        FormQuestion,
        RadioSelectQuestion,
        ReviewDetails,
        GpPrompt,
        NHSLookup
    },
    name: "component",
    data() {
        return {
            doNotShow: false,
            manualEntryValue: false,
            manualEntryPrefilled: false,
            initialSearchTerm: false,
            selectedView: 'guide',
            loadedAnswer: null,
            clinicianType: null,
            pathway: null,
            questionnaire: [],
            questionIndex: 0,
            questionHistory: [],
            currentQuestion: null,
            questionLoaded: false,
            questionAnswer: [],
            questionnaireLoaded: false,
            answeredQuestions: [],
            showErrors: false,
        };
    },
    mounted() {
        let doNotShow = localStorage.getItem('doNotShowPrompt');
        if (doNotShow) {
            this.selectedView = 'start';
        }
        this.$tag.event('booking_journey_started', { U16_booking_flag: 'N' });
        this.getBookings();
        if (this.$route.query.qh) {
            this.selectedView = 'journey';
            if (this.$route.query.appt_type) {
                this.clinicianType = this.$route.query.appt_type;
            }
            this.questionHistory = this.$route.query.qh;
            let id = this.$route.query.qh[this.$route.query.qh.length - 1];
            this.previousQuestion(id);
        } else {
            this.getQuestionnaireStart();
        }
        //else this.getUserQuestion with last id in item array as question
    },
    beforeDestroy() {

    },
    methods: {
        toggleDoNotShow() {
            this.doNotShow = !this.doNotShow;
        },
        manualEntry(org, searchTerm) {
            this.manualEntryPrefilled = false;
            let self = this;
            this.scrollToRef();
            this.manualEntryValue = true;
            if (org) {
                this.manualEntryPrefilled = true;
                this.initialSearchTerm = searchTerm;
                this.updateAnswer({
                    question_id: 'DGB005', items: [
                        { type: 'input', value: org.name },
                        { type: 'input', value: org.address },
                        { type: 'input', value: org.town },
                        { type: 'input', value: org.post_code },
                    ]
                })
            } else {
                this.initialSearchTerm = false;
                this.updateAnswer({
                    question_id: 'DGB005', items: [
                        { type: 'input', value: '' },
                        { type: 'input', value: '' },
                        { type: 'input', value: '' },
                        { type: 'input', value: '' },
                    ]
                })
            }
        },
        processAnswerTagging() {
            if (this.currentQuestion.id === 'DGB015') {
                this.$tag.event('medical_profile_reviewed', { U16_booking_flag: "N" });
            }
            if (this.currentQuestion.id === 'DGB016') {
                this.$tag.event('booking_symptom_selected', { care_pathway: this.pathway, U16_booking_flag: "N" });
            }
        },
        async getBookings() {
            let self = this;
            const payload = {
                user_id: this.$store.getters.user_id,
            };
            let res = await axios.post(
                config.api_env + "/application/api/u/gp/get-bookings",
                payload,
                config.options
            );
            if (res.data.success) {
                if (res.data.bookings.length > 1) self.openErrorModal("You're already booked in", "Go to your appointments area to manage your bookings", false, true);
            }
        },
        async getQuestionnaireStart() {
            // console.log(config);
            let res = await axios.get(
                config.matchtech_api_env + "/quiz/start-questionnaire",
                this.matchTechOptions
            );
            if (res.data) {
                this.questionLoaded = true;
                this.currentQuestion = res.data.question;
                if (res.data.question.id === 'DGB015') {
                    // if user has medical history we start from and display review_form and let user continue from there
                    // TODO probably we need to find a cleaner way of handling this
                    this.questionAnswer = { question_id: res.data.question.id, items: [{ value: '', target_id: res.data.question.target_id }] };
                }
            } else if (res.data.start_sso_journey) {
                this.openErrorModal('Your session has expired', "Please log in and try again.", true);
            } else if (res.data.err && res.data.err.includes("3994")) {
                this.openErrorModal('Your session has expired', "Please log in and try again.", true);
            } else {
                this.openErrorModal("Sorry, we've had a problem", "Please try again. <br /> <br /> If the problem persists please call us on <b>0345 608 0898</b>. We’re here to help Mon-Fri 8am-6pm, Sat 8am-4pm");
            }
        },
        async answerQuestion(newType = false) {
            this.loadedAnswer = null;
            // check if any answer in answers array is empty here

            if (!this.questionIsAnswered) {
                return this.showErrors = true;
            }
            this.manualEntryValue = false;

            //save answer if question target id is
            if (this.currentQuestion.id === 'DGB016') {
                this.clinicianType = this.questionAnswer.items[0].specialist // hmm why do we hard code it here ?
                this.pathway = this.questionAnswer.items[0].value
            }
            if (this.questionAnswer?.items[0]?.target_id === 'DGB003_under_16') {
                let href = process.env.VUE_APP_U16_URL;
                return window.location.replace(href);
            }
            let res = await axios.post(
                config.matchtech_api_env + "/quiz/answer-question",
                this.questionAnswer,
                this.matchTechOptions
            );
            if (res.data) {
                this.processAnswerTagging();
                if (res.data.next_question === null || this.$route.query.selectedTimeslotId) {
                    if (this.currentQuestion.id !== 'DGB018') {
                        this.questionHistory.push(this.currentQuestion.id)
                    }
                    let query = { qh: this.questionHistory, appt_type: newType ? newType : this.clinicianType }
                    if (this.$route.query.selectedTimeslotId) {
                        query.selectedDate = this.$route.query.selectedDate
                        query.selectedDeliveryType = this.$route.query.selectedDeliveryType
                        query.selectedTimeslotId = this.$route.query.selectedTimeslotId
                        query.selectedGenderType = this.$route.query.selectedGenderType
                    }
                    return this.$router.push({ name: 'gpSelect', params: { appt_type: newType ? newType : this.clinicianType, pathway: this.pathway }, query: query })
                    //add a param here to say you came from booking journey
                    // this.$router.push('/gp/select/' + this.clinicianType)
                }
                this.questionHistory.push(this.currentQuestion.id)
                this.currentQuestion = res.data.next_question;
                if (res.data.next_question.answers) {
                    this.loadedAnswer = res.data.next_question.answers;
                }
                if (res.data) {
                    this.answeredQuestions = res.data.next_question.answers
                    this.questionAnswer = { question_id: res.data.next_question.id, items: [{ value: '', target_id: res.data.next_question.target_id }] };
                } else {
                    this.questionAnswer = [];
                }
                this.showErrors = false;
            } else if (res.data.start_sso_journey) {
                this.openErrorModal('Your session has expired', "Please log in and try again.", true);
            } else if (res.data.err && res.data.err.includes("3994")) {
                this.openErrorModal('Your session has expired', "Please log in and try again.", true);
            } else {
                this.openErrorModal("Sorry, we've had a problem", "Please try again. <br /> <br /> If the problem persists please call us on <b>0345 608 0898</b>. We’re here to help Mon-Fri 8am-6pm, Sat 8am-4pm");
            }
        },
        updateAnswer(answer) {
            this.questionAnswer = answer;
            this.showErrors = false;
        },
        nextQuestion(newType) {
            this.scrollToRef();
            this.answerQuestion(newType);
        },
        async previousQuestion(id) {
            if (this.manualEntryValue === true) {
                return this.manualEntryValue = false;
            }
            this.showErrors = false;
            let questionId;
            if (id) {
                let questionIndex = this.questionHistory.indexOf(id)
                this.questionHistory.splice(questionIndex);
                questionId = id;
            } else {
                questionId = this.questionHistory.pop();
            }
            let res = await axios.get(
                config.matchtech_api_env + "/quiz/get-user-question/?question_id=" + questionId,
                this.matchTechOptions
            );
            if (res.data) {
                this.currentQuestion = res.data;
                this.questionLoaded = true;
                if (res.data.answers) {
                    this.loadedAnswer = res.data.answers;
                    if (res.data.answers[0].value === "") {
                        this.questionAnswer = { question_id: res.data.id, items: [{ value: '', target_id: res.data.target_id }] };
                    }
                } else {
                    this.questionAnswer = { question_id: res.data.id, items: [{ value: '', target_id: res.data.target_id }] };
                }
            } else if (res.data.start_sso_journey) {
                this.openErrorModal('Your session has expired', "Please log in and try again.", true);
            } else if (res.data.err && res.data.err.includes("3994")) {
                this.openErrorModal('Your session has expired', "Please log in and try again.", true);
            } else {
                this.openErrorModal("Sorry, we've had a problem", "Please try again. <br /> <br /> If the problem persists please call us on <b>0345 608 0898</b>. We’re here to help Mon-Fri 8am-6pm, Sat 8am-4pm");
            }
        },
        openRedirectModal() {
            const content = this.$createElement(RedirectModal)
            const skin = this.$store.getters.skin;
            let opts = {
                hideHeader: true,
                hideFooter: true,
                modalClass: "coach_modal theme-" + skin,
                size: "sm",
                buttonSize: "sm",
                centered: true,
                contentClass: "coach_modal",
                id: 'redirect-modal'
            }
            return this.$bvModal.msgBoxOk(content, opts);
        },
        openErrorModal(title, error, redirect, goBack) {
            const content = this.$createElement(ErrorModal, { props: { title, error, redirect, goBack } })
            const skin = this.$store.getters.skin;
            let opts = {
                hideHeader: true,
                hideFooter: true,
                modalClass: "coach_modal theme-" + skin,
                size: "md",
                buttonSize: "sm",
                centered: true,
                contentClass: "coach_modal",
                id: 'error-modal'
            }
            return this.$bvModal.msgBoxOk(content, opts);
        },
        selectView(view) {
            if (view === 'start') {
                if (this.doNotShow) {
                    console.log('setting doNotShow')
                    localStorage.setItem('doNotShowPrompt', true);
                }
            }
            this.scrollToRef();
            this.selectedView = view;
        }
    },
    computed: {
        questionIsAnswered() {
            let answered = true;
            if (this.currentQuestion.type === "review_form" || this.currentQuestion.type === "gp_prompt") return true;
            if (this.questionAnswer.length === 0) {
                answered = false;
            } else {
                if (this.questionAnswer.items !== undefined) {
                    this.questionAnswer.items.forEach(item => {
                        console.log(item);
                        if (item.value === '') {
                            if (item.type !== 'file') {
                                answered = false;
                            }
                        } else {
                            if (item.type === 'date') {
                                answered = !moment(item.value).isAfter(moment())
                            }
                        }

                    })
                }
            }
            return answered;
        },
        matchTechOptions() {
            return this.getMatchTechOptions();
        },
    },
    props: ['prop'],
};
</script>
<style lang="less">
#MatchTech {
    padding-top: 60px;
    background-color: #f3f5f8;
    min-height: 800px !important;

    .banner-container {
        text-align: left !important;
        background-color: white;
        padding: 20px;
        border-radius: 16px;
        width: 100%;




        .info-row {
            position: relative;
            margin-bottom: 20px;
        }

        img {
            padding: 0;
            margin-bottom: 20px;
        }

        h3 {
            font-size: 1.6rem;
            margin: 0;
            padding-top: 0;
            text-align: left;
            padding-bottom: 20px
        }

        h2 {
            width: 100%;
            font-size: 2.8rem;
            margin: 0;
            text-align: left;
            padding-bottom: 20px;
        }

        p {
            font-size: 1.4rem;
            text-align: left;
            margin: 0;
            padding: 0;
        }

        h4 {
            margin-top: 5px;
            margin-bottom: 0;
            padding-bottom: 0;
            font-size: 1.6rem;
        }

        .circle-number {
            position: absolute;
            top: 4px;
            left: 8.5px;
            color: white;
            margin-right: 2px;
            text-align: left;
            z-index: 10000;
            font-size: 1.2rem;
        }


        i {
            z-index: 1000;
            font-size: 2.4rem;
        }

        @media screen and (max-width: 768px) {
            .connect-line {
                height: 60% !important;
            }
        }

        .connect-line {
            position: absolute;
            width: 2px;
            height: 60%;
            background: #DDE1E6;
            top: 27px;
            left: 10.5px;
            z-index: 10;
            border-radius: 16px;
        }

        .info-icon-container {
            color: #DDE1E6;

            i {
                font-size: 2rem;
            }
        }

        .info-row.not-collapsed {
            i {
                transform: rotate(180deg);
            }

            .connect-line {
                height: 85%;
            }
        }
    }

    .do-not-ask-container {
        margin-top: 25px;
        width: 100%;
        padding: 20px;
        font-size: 1.6rem;
        background-color: #DDEDF8;
        border-radius: 12px;
        display: flex;
        align-items: center;

        i {
            font-size: 2.5rem;
            margin-right: 10px;
        }
    }

    .back-button-container {
        font-size: 1.4rem;
        font-weight: bold;
        font-family: 'Montserrat';
        font-weight: 700;

        .back-button {
            cursor: pointer;
        }
    }

    .button-row {
        display: flex;
        flex-direction: row;
        justify-content: center;
        gap: 20px;
        margin-bottom: 60px;
    }

    .warning-container {
        max-width: 600px;
        font-size: 1.6rem;

        h3 {
            padding-top: 0;
            margin-top: 0;
            letter-spacing: normal;
            font-size: 1.8rem;
        }

        .warning-info-container {
            font-family: "Montserrat", serif;
            font-weight: 600;
            background-color: white;
            padding: 20px;
            border: 2px solid #D60023;
            border-radius: 16px;
            margin-bottom: 25px;

            i {
                color: #D60023;
            }
        }

        .btn {
            margin-top: 30px;
            margin-bottom: 100px;
        }
    }
}
</style>
